module.exports = __webpack_public_path__ + "media/damages/car-rr@2x-647e4ff9.png";